import React, { useState } from 'react';
import Moment from 'moment';
import { DateRangePicker } from 'react-dates';
import styled from '@emotion/styled';
import './Audit.css';

const DateRangeWrapper = styled.div`
  position: relative;
  width: 48%;
  min-width: 250px;
  
  .DateRangePicker {
    width: 45%;
    display: flex;
    justify-content: space-between;
  }

  .DateRangePickerInput {
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    background: white;
  }

  .DateInput {
    width: 50%;
    height: 100%;
    padding: 0 5px;
  }

  .DateInput_input {
    height: 100%;
    border: none;
    background: transparent;
    text-align: center;
    &:focus {
      outline: none;
    }
  }

  .DateRangePickerInput_arrow {
    margin: 0 8px;
  }

  .DateRangePickerInput_clearDates {
    margin: 0 8px;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
    &:hover {
      background: none;
    }
  }

  .CalendarDay {
    border: none;
    &:hover {
      background: #f8f9ff;
    }
  }

  .CalendarDay__selected {
    background: #597EF7;
    color: white;
    &:hover {
      background: #597EF7;
    }
  }

  .CalendarDay__hovered_span {
    background: #f8f9ff;
    color: #1a1a1a;
    &:hover {
      background: #f8f9ff;
    }
  }

  .CalendarDay__selected_span {
    background: #f8f9ff;
    color: #1a1a1a;
    &:hover {
      background: #f8f9ff;
    }
  }

  .DayPicker {
    z-index: 9999;
  }

  .DayPicker__withBorder {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: 1px solid #e5e7eb;
    border-radius: 4px;
  }
  .DateRangePickerInput.DateRangePickerInput_1::after {
    left: 48%;
    top: 10px;
  }
`;

const fieldNames = [
  {value: 'provider_name', label: 'Transporter'},
  {value: 'vehicle_type', label: 'Vehicle Type'},
  {value: 'contract_type_name', label: 'Contract Type'},
  {value: 'route_code', label: 'Route Code'},
  {value: 'vehicle_reg_no', label: 'Vehicle Reg. No.'},
  {value: 'fixed_cost', label: 'Fixed Cost'},
  {value: 'excluded_route_code', label: 'Excluded Route Code'},
  {value: 'included_route_code', label: 'Included Route Code'},
  {value: 'billing_parameter_name', label: 'Billing Parameter'},
  {value: 'trip_count', label: 'Trip Count'},
  {value: 'freight_rate', label: 'Freight Rate'},
  {value: 'contract_tenure_from', label: 'Contract Tenure From'},
  {value: 'contract_tenure_to', label: 'Contract Tenure To'},
];

const AuditLog = ({auditData, search, fromDate, toDate, handleEditDateChange, handleSearch}) => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);

  const toggleRow = (index) => {
    setExpandedIndex(prev => (prev === index ? null : index));
  };

  const getFiledName = (field) => {
    const displayName = fieldNames.find((fn) => fn.value == field);
    if(displayName){
      return displayName.label;
    }
  }
  
  const getFieldValue = (value, field) => {
    let formattedValue = value;
    if(['contract_tenure_from', 'contract_tenure_to'].includes(field)){
      formattedValue = Moment(value).format('DD/MM/YYYY')
    }
    return formattedValue
  }

  return (
    <div className="audit-container">
      <div className="audit-filters-bar">
        <input
          type="text"
          className="search-input"
          placeholder="Search by Route Code"
          value={search}
          onChange={(e) => handleSearch(e.target.value)}
        />
        <DateRangeWrapper>
        <DateRangePicker
          startDate={fromDate ? Moment(fromDate) : null}
          endDate={toDate ? Moment(toDate) : null}
          onDatesChange={handleEditDateChange}
          focusedInput={focusedInput}
          onFocusChange={focusedInput => setFocusedInput(focusedInput)}
          startDatePlaceholderText="Start"
          endDatePlaceholderText="End"
          displayFormat="DD/MM/YYYY"
          numberOfMonths={2}
          showClearDates
          small
          withPortal
          appendToBody
          isOutsideRange={() => false}
        />
        </DateRangeWrapper>
      </div>

      <table className="audit-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>By</th>
            <th>Transporter Name</th>
            <th>Route Code</th>
            <th>No of Changes</th>
            <th>Value</th>
            <th>Previous</th>
            <th>Current</th>
            <th className="action-cell">Action</th>
          </tr>
        </thead>
        <tbody>
          {auditData.map((entry, index) => (
            <React.Fragment key={index}>
              <tr className="main-row">
                <td>{entry.updated ? Moment(entry.updated).format('DD/MM/YYYY, hh:mm a') : Moment(entry.created_on).format('DD/MM/YYYY, hh:mm a')}</td>
                <td>{entry.user_name}</td>
                <td>{entry.provider_name}</td>
                <td>{entry.route_code}</td>
                <td>{entry.edited_logs && entry.edited_logs.length}</td>
                <td>{entry.edited_logs && entry.edited_logs.length > 0 && getFiledName(entry.edited_logs[0].field)}</td>
                <td>{entry.edited_logs && entry.edited_logs.length > 0 && getFieldValue(entry.edited_logs[0].previous_value, entry.edited_logs[0].field)}</td>
                <td>{entry.edited_logs && entry.edited_logs.length > 0 && getFieldValue(entry.edited_logs[0].current_value, entry.edited_logs[0].field)}</td>
                <td className="action-cell">
                  {entry.action}
                  {entry.edited_logs && entry.edited_logs.length > 1 && (
                    <span
                      className="dropdown-icon"
                      onClick={() => toggleRow(index)}
                    >
                      {expandedIndex === index ? '▴' : '▾'}
                    </span>
                  )}
                </td>
              </tr>
              {expandedIndex === index && entry.edited_logs && entry.edited_logs.length > 1 && (
                <tr className="expanded-row">
                 <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colSpan="3">
                  <table className="details-table">
                    {/* <thead>
                      <tr>
                        <th>Field</th>
                        <th>Previous</th>
                        <th>Current</th>
                      </tr>
                    </thead> */}
                    <tbody>
                      {entry.edited_logs.slice(1).map((log, idx) => (
                        <tr key={idx + 1}> {/* Adjust key to avoid duplicates */}
                          <td className="details-label">{getFiledName(log.field)}</td>
                          <td className="details-prev">{getFieldValue(log.previous_value, log.field)}</td>
                          <td className="details-curr">{getFieldValue(log.current_value, log.field)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </td>
                <td></td>

                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AuditLog;
